import { StageDefinition } from './StageDefinition';

export const stage08: StageDefinition = {
    platforms: [
        [23.225806451612904, 0],
        [28.421052631578945, 1],
        [37.89473684210526, 1],
        [47.368421052631575, 1],
        [136.8, 3],
        [132.63157894736838, 4],
        [131.42857142857136, 5],
        [159.99999999999997, 5],
        [165.7142857142857, 5],
        [171.42857142857142, 5],
        [177.14285714285714, 5],
        [182.85714285714286, 5],
        [188.57142857142858, 5],
        [194.2857142857143, 5],
        [130.43478260869568, 6],
        [129.59999999999997, 7],
        [127.31707317073172, 8],
        [126.81818181818187, 9],
    ],
    traps: [
        [81.29032258064515, 0],
        [290.3225806451614, 0],
        [172.79999999999995, 3],
        [179.99999999999994, 3],
    ],
    stars: [
        [52, 0],
        [136, 7],
        [182, 6],
        [195, 8],
        [212, 10],
    ],
};
